import classNames from 'classnames';
import CloseButton from '@/shared/components/configurator/CloseButton';
import ConstructorButton from '@/shared/components/configurator/ConstructorButton';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useSetConfiguratorStepState } from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import { useCurrentGroupPickerStateValue } from '@/shared/components/configurator/atoms/current-group-picker-state';
import {
    ModelState,
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { useCurrentModelTypeValue } from '@/shared/components/configurator/atoms/current-model-type';
import { additionalDict } from '@/shared/components/configurator/dicts/additional-dict';

const ConfiguratorGroupPicker = () => {
    const setStep = useSetConfiguratorStepState();
    const picker = useCurrentGroupPickerStateValue();
    const currentModelState = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const slug = picker.title === 'Внутренняя зона №2' ? 'group-2' : 'group-1';
    const currentModelType = useCurrentModelTypeValue();
    return (
        <div className="configurator">
            <div className="configurator-top">
                <div className="configurator-title text-l">{picker.title}</div>
                <CloseButton
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                />
            </div>
            <div className="configurator-group-picker configurator-body">
                {picker.values.map((item, i) => {
                    return (
                        <div key={i} className="configurator-group">
                            <div className="configurator-group-title text-m">{item.title}</div>
                            <ul className="group-picker-list list-unstyled">
                                {item.property.map((innerItem, j) => {
                                    const currentModelPicker = currentModelState[item.slug];
                                    return (
                                        <li key={j}>
                                            <button
                                                className={classNames('picker-item', {
                                                    //@ts-ignore появляется из-за мультипикера, которого тут нет
                                                    'picker-item--active': currentModelPicker?.value === innerItem.slug,
                                                })}
                                                onClick={() => {
                                                    setCurrentModelState((prev) => {
                                                        if (prev[item.slug]?.value === innerItem.slug) {
                                                            const newObj = Object.fromEntries(
                                                                Object.entries(prev).filter(
                                                                    ([key]) => key !== item.slug,
                                                                ),
                                                            );
                                                            return newObj as ModelState;
                                                        }
                                                        return {
                                                            ...prev,
                                                            [item.slug]: {
                                                                title: innerItem.label,
                                                                value: innerItem.slug,
                                                            },
                                                        };
                                                    });
                                                }}
                                            >
                                                <div className="text-m">{innerItem.label}</div>
                                                <div className="text-s picker-hint">{innerItem.hint}</div>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}

                {currentModelType === 'premium' && additionalDict[slug].length > 0 && (
                    <div className="configurator-additional">
                        <div className="text-m">Дополнительные варианты</div>
                        <div className="configurator-additional-hint text-xxs">
                            Перечисленные варианты являются примерными. Предустановки, указанные в этом конфигураторе,
                            могут быть объединены. Элементы стенда могут меняться и могут быть изменены по запросу
                            клиента.
                        </div>

                        <ul className="list-styled">
                            {additionalDict[slug].map((item, i) => {
                                return (
                                    <li className="text-xxs" key={i}>
                                        {item}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>

            <div className="configurator-hero-buttons configurator-color-picker-buttons">
                <ConstructorButton
                    variant="blue"
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                >
                    Сохранить и закрыть
                </ConstructorButton>
            </div>
        </div>
    );
};

export default ConfiguratorGroupPicker;
